<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import ReadMoreIndowStories from '$lib/PageSections/ReadMoreIndowStories/ReadMoreIndowStories.svelte';

	import indowWindowClose from './images/indow-window-close.jpg';
	import indowPool from './images/inodw-pool.jpg';
	import officeInside from './images/office-inside.jpg';
	import stopWindowCondensation from './images/stop-window-condensation.jpg';
	import treeOut from './images/tree-out.jpg';
</script>

<Section>
	<p>
		The Mid-Century Modern Home was a gem, but like many vintage homes, it had a
		few wrinkles that the new owners, Greg and Eddie, would have to iron out.
		One of their biggest problems was how to stop window condensation that
		repeatedly formed on their clerestory windows.
	</p>
	<Image
		src={treeOut}
		alt="outside view of home with Indow inserts that stop window condensation"
		loading="eager"
	/>
	<p>
		The house was built in 1959 for dress designer Ed Cupaioli and his wife
		Margaret, an NBC radio and Broadway singer. It is a mid-century modern with
		carrara marble flooring throughout, red oak molding that makes the walls
		look like Japanese shoji screens, large windows and a free form pool
		outback. The couple entertained in the house, which saw its share of
		illustrious guests: Tony Bennett, Frank Sinatra, Doris Day, Ann Miller. It
		is easy to picture them there.
	</p>
	<Image
		src={officeInside}
		alt="clerestory windows with Indow inserts to stop condensation"
	/>
	<p>
		When Mrs. Cupaioli died at 96 and the property went up for sale in 2012,
		prospective buyers made offers to tear it down and build something new. Greg
		Nieberding and his partner, Eddie Ortega, bought it to restore and preserve.
		A gem, the house was designed by Jack Wood, who studied under Eliel Saarinen
		at Cranbrook Academy of Art in Bloomfield, Michigan. One of his classmates,
		Greg said, was Florence Knoll of Knoll furniture.
	</p>
</Section>
<Section backgroundColor="grey-light">
	<h2>Testimonials</h2>
	<Image
		src={stopWindowCondensation}
		alt="homeowner outside his windows with Indow inserts that stop window condensation"
	/>
	<p class="text-indow-blue! italic">
		“It’s the coolest house I’ve ever seen – and I’ve seen them in Palm Springs
		– this one takes the cake in my book. We get the most incredibly warm
		feeling from this house, I feel like I’ve been blessed with this great
		opportunity. I can’t imagine someone thinking of tearing it down. I couldn’t
		be more pleased. The Indow inserts have a very low profile.”
	</p>
	<p>– Greg Nieberding, Home Owner, Dallas, Texas</p>
	<a href="/resources/case-studies">Read more case studies.</a>
</Section>
<Section>
	<h2>Removing window condensation while preserving aesthetics</h2>
	<p>
		But the roof needed replacing. And the fog forming on the clerestory windows
		in the bedroom had the couple searching for a window condensation fix. Since
		the glass was built into the walls, it would have been a major project to
		replace them. Such window challenges aren’t uncommon in custom-designed
		mid-century modern homes, but removing window condensation can be tricky.
		Greg and Eddie turned to Indow window inserts which block moisture from
		reaching the window panes. They selected Indow <a
			href="/products/thermal-window-inserts">Standard Grade</a
		> inserts.
	</p>
	<p>
		Not only did the window condensation vanish, but the drafts did too, it
		became quieter. And the inserts corrected the flaws around the edge of the
		tinting Greg had applied to the clerestory windows. The Indow inserts gave
		it a finished look.
	</p>
	<Image src={indowPool} />
	<p>
		It’s in a gated community with friendly neighbors. Former President George
		W. Bush and his wife, Laura, welcomed Greg and Eddie by knocking on the door
		and presenting a book and handmade Christmas ornament the former president
		had painted in his spare time.
	</p>
	<p>
		Greg said he’s pretty sure Mrs. Cupaioli would be happy with what he and his
		partner have done to restore the house.
	</p>
	<Image src={indowWindowClose} />
	<hr />
</Section>
<ReadMoreIndowStories />
<GetAFreeEstimate />
